import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'automationTemplate/meetingReminders';

export interface IMeetingReminderTemplate {
	id: string;
	name: string;
	creator?: {
		firstName?: string;
		lastName?: string;
	};
}

export function useMeetingReminderTemplatesQuery() {
	const userSession = useUserSession();

	return useQuery({
		queryFn: async () => {
			const result = await userSession.webServiceHelper.callAsync<IMeetingReminderTemplate[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'automationTemplate/meetingReminders',
				}),
				'GET'
			);
			return result;
		},
		queryKey: [BASE_QUERY_KEY],
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
}
